/**
 * Helper to safely format image URLs for both Web (Vercel/HTTP) and Electron (file:// protocol).
 * 
 * - On Vercel / Web (HTTP/HTTPS): Uses standard domain-root paths like `/user.png`.
 * - On Electron (file://): Uses relative paths like `./user.png` to avoid Chromium 
 *   "Not allowed to load local resource" errors.
 */
export const getImageUrl = (imageSrc) => {
  const isElectron = typeof window !== "undefined" && window.location.protocol === "file:";

  if (!imageSrc || imageSrc === "/user.png" || imageSrc === "user.png") {
    return isElectron ? "./user.png" : "/user.png";
  }

  if (typeof imageSrc === "string") {
    if (imageSrc.startsWith("http://") || imageSrc.startsWith("https://") || imageSrc.startsWith("data:")) {
      return imageSrc;
    }
    // Handle Cloudinary public IDs (e.g. oipm1ecb1yudf9eln7az.jpg)
    if (imageSrc.includes("cloudinary.com") || imageSrc.match(/^[a-zA-Z0-9_-]+\.(jpg|jpeg|png|webp|gif)$/i)) {
      return `https://res.cloudinary.com/dwyx8n0pt/image/upload/${imageSrc}`;
    }
    if (imageSrc.startsWith("/")) {
      return isElectron ? `.${imageSrc}` : imageSrc;
    }
  }

  return imageSrc || (isElectron ? "./user.png" : "/user.png");
};

/**
 * Image error handler fallback to prevent broken image icons on both Web and Electron.
 */
export const handleImageError = (e) => {
  if (e && e.target) {
    const isElectron = typeof window !== "undefined" && window.location.protocol === "file:";
    const fallback = isElectron ? "./user.png" : "/user.png";
    if (!e.target.src.endsWith("user.png")) {
      e.target.onerror = null;
      e.target.src = fallback;
    }
  }
};
